class IntersectionHandler extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['observable']
  }

  static get observedAttributes () {
    return ['threshold']
  }

  connectedCallback () {
    super.connectedCallback()

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(
      this.intersectionObserverCallback.bind(this),
      {
        threshold: this.threshold,
      },
    )

    this.els?.observable?.elements?.forEach(observableEl =>
      this.observer.observe(observableEl),
    )
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.observer?.disconnect()
  }

  intersectionObserverCallback (entries) {
    if (!entries?.length) return

    entries.forEach(entry => {
      entry?.target?.setAttribute('data-intersecting', entry?.isIntersecting)

      const intersectedFromBottom =
        entry?.isIntersecting && entry?.boundingClientRect?.top > 0
      entry?.target?.setAttribute(
        'data-intersected-from-bottom',
        intersectedFromBottom,
      )

      const intersectedFromTop =
        entry?.isIntersecting && entry?.boundingClientRect?.top < 0
      entry?.target?.setAttribute(
        'data-intersected-from-top',
        intersectedFromTop,
      )

      if (!entry?.isIntersecting) return
      entry?.target?.setAttribute('data-has-intersected', 'true')
    })
  }

  get threshold () {
    return this.hasAttribute('threshold')
      ? Number(this.getAttribute('threshold'))
      : 0
  }
}

if (!customElements.get('intersection-handler')) {
  customElements.define('intersection-handler', IntersectionHandler)
}
